export const LATE_STAGE_PAYWALL_LAUNCH_EVENT = 'vimeo:late-stage-paywall-launch';

type LateStagePaywallLaunchDetail = {
  url: string;
};

export const launchLateStagePaywallFromUpgradePlanUrl = (url: string): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const launchEvent = new CustomEvent<LateStagePaywallLaunchDetail>(
    LATE_STAGE_PAYWALL_LAUNCH_EVENT,
    {
      cancelable: true,
      detail: { url },
    },
  );

  window.dispatchEvent(launchEvent);

  return launchEvent.defaultPrevented;
};
